import { H1, H3 } from '@wheely/ui-kit';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';

import { REGISTER_ROUTE } from '../../routes';

import s from './style.module.css';

const Header: React.FC = () => {
  const isRegisterView = useLocation().pathname === REGISTER_ROUTE;

  return (
    <header className={s.header} data-test-id="quest-header">
      <H3 capitalize={true} className={s.subtitle} data-test-id="quest-header__title">
        <FormattedMessage
          defaultMessage="Wheely for Chauffeurs"
          id="tIx+rU"
          description="Wheely for Chauffeurs title"
        />
      </H3>
      <H1 capitalize={true} className={s.title} data-test-id="quest-header__sign-in-title">
        {isRegisterView ? (
          <FormattedMessage
            defaultMessage="Sign Up"
            id="login_header_sign_up_title"
            description="Sign up form title"
          />
        ) : (
          <FormattedMessage defaultMessage="Sign In" id="3GH14G" description="Sign in form title" />
        )}
      </H1>

      <div data-test-id="quest-header__sign-up">
        {isRegisterView ? (
          <FormattedMessage
            defaultMessage="Already have an account? <link>Sign in</link>"
            id="login_header_sign_in_link"
            description="Sign up form sign in link"
            values={{
              link: (text: React.ReactNode) => <Link to="/login">{text}</Link>,
            }}
          />
        ) : (
          <FormattedMessage
            defaultMessage="Don't have an account? <link>Sign up</link>"
            id="lgP7bC"
            description="Sign in form sign up link"
            values={{
              link: (text: React.ReactNode) => <Link to={REGISTER_ROUTE}>{text}</Link>,
            }}
          />
        )}
      </div>
    </header>
  );
};

export { Header };
